import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import ComingSoon from './ComingSoon';
var LazyApp = ComingSoon;
if (window.location.href.endsWith('/testing')) {
    LazyApp = React.lazy(function () { return import('./App'); });
}
var rootEl = document.querySelector('#react-root');
var root = ReactDOM.createRoot(rootEl);
root.render(_jsx(React.Suspense, { fallback: _jsx("div", { children: "Loading..." }), children: _jsx(LazyApp, {}) }));
